import React from "react";
import "./CustomButton.css";
import {motion} from 'framer-motion'
import { a } from "framer-motion/client";

const CustomButton = ({ text,sectionRef }) => {

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (

      <motion.button  initial={{opacity:0,translateY:10}} whileInView={{opacity:1,translateY:0}} viewport={{once:true}} transition={{duration:1.5}} className="connect-btn border-anim" onClick={() => scrollToSection(sectionRef)}>
      <div className="inner lg:w-[250px] md:w-[200px] w-[180px] text-sm h-[50px] flex items-center justify-center">
        <p>{text}</p>
      </div>
    </motion.button>

 
  );
};

export default CustomButton;
